var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90039 10.2422C5.82201 10.2285 5.74974 10.1979 5.68457 10.1543L5.5918 10.0791L5.58887 10.0762L5.51465 9.98926C5.44769 9.89615 5.40625 9.78621 5.40625 9.66211C5.40632 9.53799 5.44762 9.42823 5.51465 9.33496L5.58887 9.24805L8.78516 6.05273H1.66895C1.51182 6.05273 1.36729 5.99717 1.25391 5.88379C1.14055 5.77041 1.08496 5.62586 1.08496 5.46875C1.08502 5.35094 1.1163 5.24026 1.17969 5.14453L1.25391 5.05469C1.36729 4.9413 1.51182 4.88574 1.66895 4.88574L8.78418 4.88574L5.58496 1.68652C5.50443 1.60594 5.44961 1.50944 5.42481 1.40137L5.41016 1.28906V1.28809L5.41992 1.16504C5.44345 1.04765 5.50604 0.945595 5.59082 0.861329L5.5918 0.859376C5.70014 0.753676 5.83717 0.682242 5.99805 0.679689H5.99902C6.16513 0.677922 6.30512 0.753048 6.41406 0.861329H6.41504L10.4678 4.91504L10.4687 4.91602C10.5447 4.99253 10.6076 5.07995 10.6465 5.17969C10.6824 5.27197 10.6992 5.36922 10.6992 5.46875C10.6992 5.5684 10.6825 5.6664 10.6465 5.75879C10.6075 5.85876 10.544 5.94621 10.4678 6.02246L6.41504 10.0762L6.33008 10.1475C6.24009 10.2095 6.13606 10.2434 6.02344 10.249L5.90039 10.2422Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.f95ed3c5a4b08b8abf2ecd3a13cd70d0.svg";
export { ForwardRef as ReactComponent };